import { render, staticRenderFns } from "./PermissionPane.vue?vue&type=template&id=533fdd57&scoped=true&"
import script from "./PermissionPane.vue?vue&type=script&lang=js&"
export * from "./PermissionPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533fdd57",
  null
  
)

export default component.exports